import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { apiFetch } from 'utils/apiFetch'

export const serviceCenterNodeServiceIssuesGet = async (
  params: Partial<routes.ServiceCenterNodeServiceIssuesGet.Request> &
    Required<Pick<routes.ServiceCenterNodeServiceIssuesGet.Request, 'propertyIds'>>,
) => {
  const serviceIssues = await apiFetch({
    url: '/service-center-node-service-issues-get',
    body: params,
    params: { useCache: true },
  })

  return serviceIssues
}
